import moment from 'moment';

export const getStartAndEndDate = (year, month) => {
    const mm = String(month + 1).padStart(2, '0');
    const start = `${year}-${mm}-01`;
    const lastDay = new Date(year, month + 1, 0).getDate();
    const end = `${year}-${mm}-${String(lastDay).padStart(2, '0')}`;
    return { start, end };
  };
  export  const colorMap = {
    booked: '#A2D5AB',
    check_in: '#FFB703',
    check_out: '#FFE3A3',
    cancelled: '#F08080'
  };
  export const occupancyOptions = [
    { value: 'all', label: 'All' },
    { value: '1', label: '1 Person' },
    { value: '2', label: '2 People' },
    { value: '3', label: '3 People' },
    { value: '4', label: '4 People' },
    { value: '5', label: '5 Person' },
    { value: '6', label: '6 People' },
    { value: '7', label: '7 People' },
    { value: '8', label: '8 People' },
    { value: '9', label: '9 Person' },
    { value: '10', label: '10 People' },
    { value: '11', label: '11 People' },
    { value: '12', label: '12 People' }
  ];
const getItemStyle = (status) => {
  switch (status) {
    case 'check_in':
      return { background: '#FFD166', color: '#000' }; // yellow
    case 'check_out':
      return { background: '#EF476F', color: '#fff' }; // red
    case 'booked':
      return { background: '#06D6A0', color: '#000' }; // green
    default:
      return { background: '#A2D5AB', color: '#000' }; // default
  }
};

export const groups = [
  { id: 100, title: 'Double Room' },
  { id: 1, title: '🟦 101', parent: 100 },
  { id: 2, title: '🟩 102', parent: 100 },
  { id: 3, title: '🟨 103', parent: 100 },
  { id: 4, title: '🟩 104', parent: 100 },

  { id: 200, title: 'Single Room' },
  { id: 5, title: '🟩 201', parent: 200 },
  { id: 6, title: '🟨 202', parent: 200 },
  { id: 7, title: '🟦 203', parent: 200 },
  { id: 8, title: '🟩 204', parent: 200 },

  { id: 300, title: 'Suite' },
  { id: 9, title: '🟨 301', parent: 300 },
  { id: 10, title: '🟦 302', parent: 300 },
  { id: 11, title: '🟦 303', parent: 300 },
  { id: 12, title: '🟨 304', parent: 300 },
  { id: 13, title: '🟩 305', parent: 300 },
  { id: 14, title: '🟦 306', parent: 300 },
  { id: 15, title: '🟦 307', parent: 300 },
];

// Update group map to point to roomType itself
const groupOnlyChildMap = {
  100: 100, // Use room type ID itself
  200: 200,
  300: 300
};

// Generate daily roomType tags directly under roomType group
const generateGroupOnlyTags = () => {
  const tags = [];
  const startOfMonth = moment().startOf('month');
  const endOfMonth = moment().endOf('month');

  let day = startOfMonth.clone();
  let tagId = 1000; 

  while (day.isSameOrBefore(endOfMonth, 'day')) {
    Object.values(groupOnlyChildMap).forEach((groupId) => {
      tags.push({
        id: `tag-${tagId++}`,
        group: groupId, // Use roomType group directly
        title: '4 rooms',
        start_time: day.clone().startOf('day'),
        end_time: day.clone().endOf('day'),
        canMove: false,
        canResize: false,
        style: {
          backgroundColor: 'transparent',
          color: '#000',
          fontSize: '12px',
          fontStyle: 'italic',
          border: 'none'
        }
      });
    });
    day.add(1, 'day');
  }

  return tags;
};

export const allItems = [
  ...generateGroupOnlyTags(),

  {
    id: 1,
    group: 1,
    title: 'Erica Mustermann',
    start_time: moment('2025-05-02'),
    end_time: moment('2025-05-10'),
    itemProps: { style: { borderRadius:'4px',borderColor:"black", background: '#A2D5AB', color: '#000' } }, // light green
  },
  {
    id: 2,
    group: 3,
    title: 'Mateus Runner',
    start_time: moment('2025-09-21'),
    end_time: moment('2025-09-23'),
    itemProps: { style: { borderRadius:'4px',borderColor:"black", background: '#FFB703', color: '#000' } }, // light orange
  },
  {
    id: 3,
    group: 2,
    title: 'Sophia Zhang',
    start_time: moment('2025-09-18'),
    end_time: moment('2025-09-20'),
    itemProps: { style: { borderRadius:'4px',borderColor:"black", background: '#FFE3A3', color: '#000' } }, // soft yellow
  },
  {
    id: 4,
    group: 4,
    title: 'Liam Patel',
    start_time: moment('2025-09-25'),
    end_time: moment('2025-09-28'),
    itemProps: { style: { borderRadius:'4px',borderColor:"black", background: '#C8F4F9', color: '#000' } }, // pale blue
  },
  {
    id: 5,
    group: 5,
    title: 'Ava Müller',
    start_time: moment('2025-09-15'),
    end_time: moment('2025-09-17'),
    itemProps: { style: { borderRadius:'4px',borderColor:"black", background: '#FDEBD0', color: '#000' } }, // peach
  },
  {
    id: 6,
    group: 6,
    title: 'Noah Kim',
    start_time: moment('2025-09-22'),
    end_time: moment('2025-09-25'),
    itemProps: { style: { borderRadius:'4px',borderColor:"black", background: '#D6EAF8', color: '#000' } }, // soft blue
  },
  {
    id: 7,
    group: 7,
    title: 'Olivia Garcia',
    start_time: moment('2025-09-19'),
    end_time: moment('2025-09-21'),
    itemProps: { style: { borderRadius:'4px',borderColor:"black", background: '#E2F0CB', color: '#000' } }, // mint green
  },
  {
    id: 8,
    group: 8,
    title: 'Lucas Rossi',
    start_time: moment('2025-09-27'),
    end_time: moment('2025-09-30'),
    itemProps: { style: { borderRadius:'4px',borderColor:"black", background: '#FADADD', color: '#000' } }, // light pink
  },
  {
    id: 9,
    group: 9,
    title: 'Emma Thompson',
    start_time: moment('2025-09-16'),
    end_time: moment('2025-09-19'),
    itemProps: { style: { borderRadius:'4px',borderColor:"black", background: '#FFFACD', color: '#000' } }, // lemon chiffon
  },
  {
    id: 10,
    group: 10,
    title: 'Jack Singh',
    start_time: moment('2025-09-23'),
    end_time: moment('2025-09-26'),
    itemProps: { style: { borderRadius:'4px',borderColor:"black", background: '#E0BBE4', color: '#000' } }, // lavender
  },
  {
    id: 11,
    group: 11,
    title: 'Many Fernández',
    start_time: moment('2025-05-20'),
    end_time: moment('2025-05-22'),
    itemProps: { style: { borderRadius:'4px',borderColor:"black",background: '#F9FBE7', color: '#000' } }, // light lime
  },
  {
    id: 12,
    group: 12,
    title: 'Henry Tanaka',
    start_time: moment('2025-06-12'),
    end_time: moment('2025-06-15'),
    itemProps: { style: { borderRadius:'4px',borderColor:"black", background: '#E6E6FA', color: '#000' } }, // lavender mist
  },
  {
    id: 13,
    group: 13,
    title: 'Isabella Brown',
    start_time: moment('2025-06-18'),
    end_time: moment('2025-06-20'),
    itemProps: { style: { borderRadius:'4px',borderColor:"black", background: '#F0FFF0', color: '#000' } }, // honeydew
  },
  {
    id: 14,
    group: 14,
    title: 'Ethan Nguyen',
    start_time: moment('2025-05-21'),
    end_time: moment('2025-06-24'),
    itemProps: { style: { borderRadius:'4px',borderColor:"black", background: '#FDF5E6', color: '#000' } }, // old lace
  },
  {
    id: 15,
    group: 15,
    title: 'Charlotte Silva',
    start_time: moment('2025-06-25'),
    end_time: moment('2025-06-28'),
    itemProps: { style: { borderRadius:'4px',borderColor:"black", background: '#F0F8FF', color: '#000' } }, // Alice Blue
  },
  {
    id: 16,
    group: 2,
    title: 'Jin Park',
    start_time: moment('2025-05-26'),
    end_time: moment('2025-05-28'),
    itemProps: { style: { borderRadius:'4px', borderColor:"black", background: '#DFF2BF', color: '#000' } }, // light green
  },
  {
    id: 17,
    group: 7,
    title: 'Anya Ivanova',
    start_time: moment('2025-05-29'),
    end_time: moment('2025-06-01'),
    itemProps: { style: { borderRadius:'4px', borderColor:"black", background: '#FFDDC1', color: '#000' } }, // light peach
  },
  {
    id: 18,
    group: 10,
    title: 'Tom Becker',
    start_time: moment('2025-05-24'),
    end_time: moment('2025-05-26'),
    itemProps: { style: { borderRadius:'4px', borderColor:"black", background: '#E1F5FE', color: '#000' } }, // pale sky blue
  },
  {
    id: 19,
    group: 10,
    title: 'Sara Mehta',
    start_time: moment('2025-06-12'),
    end_time: moment('2025-06-18'),
    itemProps: { style: { borderRadius:'4px', borderColor:"black", background: '#F5DEB3', color: '#000' } }, // wheat
  },
  {
    id: 20,
    group: 11,
    title: 'Mohammed Ali',
    start_time: moment('2025-06-05'),
    end_time: moment('2025-06-07'),
    itemProps: { style: { borderRadius:'4px', borderColor:"black", background: '#E0FFFF', color: '#000' } }, // light cyan
  },
  {
    id: 21,
    group: 12,
    title: 'Lea Dubois',
    start_time: moment('2025-06-01'),
    end_time: moment('2025-06-03'),
    itemProps: { style: { borderRadius:'4px', borderColor:"black", background: '#FAEBD7', color: '#000' } }, // antique white
  },
  {
    id: 22,
    group: 13,
    title: 'Oscar Chen',
    start_time: moment('2025-05-30'),
    end_time: moment('2025-06-01'),
    itemProps: { style: { borderRadius:'4px', borderColor:"black", background: '#E6F9E4', color: '#000' } }, // fresh mint
  },
  {
    id: 23,
    group: 14,
    title: 'Zara Khan',
    start_time: moment('2025-05-05'),
    end_time: moment('2025-05-07'),
    itemProps: { style: { borderRadius:'4px', borderColor:"black", background: '#FFF5E1', color: '#000' } }, // cream
  },
  {
    id: 24,
    group: 15,
    title: 'Daniela Souza',
    start_time: moment('2025-06-03'),
    end_time: moment('2025-06-06'),
    itemProps: { style: { borderRadius:'4px', borderColor:"black", background: '#FCE1E4', color: '#000' } }, // blush pink
  },
  {
    id: 25,
    group: 5,
    title: 'Nicolas Yamato',
    start_time: moment('2025-06-05'),
    end_time: moment('2025-06-07'),
    itemProps: { style: { borderRadius:'4px', borderColor:"black", background: '#D3F8E2', color: '#000' } }, // soft mint
  },

  {
    id: 26,
    group: 2,
    title: 'Jiny Parekar',
    start_time: moment('2025-05-01'),
    end_time: moment('2025-05-06'),
    itemProps: { style: { borderRadius:'4px', borderColor:"black", background: '#DFF2BF', color: '#000' } }, // light green
  },
  {
    id: 27,
    group: 6,
    title: 'Kanya In',
    start_time: moment('2025-05-09'),
    end_time: moment('2025-06-17'),
    itemProps: { style: { borderRadius:'4px', borderColor:"black", background: '#FFDDC1', color: '#000' } }, // light peach
  },
  {
    id: 28,
    group: 9,
    title: 'Tom Lee',
    start_time: moment('2025-05-15'),
    end_time: moment('2025-05-26'),
    itemProps: { style: { borderRadius:'4px', borderColor:"black", background: '#E1F5FE', color: '#000' } }, // pale sky blue
  },
  {
    id: 29,
    group: 10,
    title: 'Sahra Mehta',
    start_time: moment('2025-06-02'),
    end_time: moment('2025-06-04'),
    itemProps: { style: { borderRadius:'4px', borderColor:"black", background: '#F5DEB3', color: '#000' } }, // wheat
  },
  {
    id: 30,
    group: 12,
    title: 'Mohammed Hafiz',
    start_time: moment('2025-06-05'),
    end_time: moment('2025-06-10'),
    itemProps: { style: { borderRadius:'4px', borderColor:"black", background: '#E0FFFF', color: '#000' } }, // light cyan
  },
  {
    id: 31,
    group: 12,
    title: 'Lina Dubois',
    start_time: moment('2025-07-01'),
    end_time: moment('2025-07-03'),
    itemProps: { style: { borderRadius:'4px', borderColor:"black", background: '#FAEBD7', color: '#000' } }, // antique white
  },
  {
    id: 32,
    group: 12,
    title: 'Ona Chen',
    start_time: moment('2025-04-30'),
    end_time: moment('2025-05-06'),
    itemProps: { style: { borderRadius:'4px', borderColor:"black", background: '#E6F9E4', color: '#000' } }, // fresh mint
  },
  {
    id: 33,
    group: 14,
    title: 'Zara Khan',
    start_time: moment('2025-05-15'),
    end_time: moment('2025-05-20'),
    itemProps: { style: { borderRadius:'4px', borderColor:"black", background: '#FFF5E1', color: '#000' } }, // cream
  },
  {
    id: 34,
    group: 15,
    title: 'Denial Souza',
    start_time: moment('2025-05-09'),
    end_time: moment('2025-05-16'),
    itemProps: { style: { borderRadius:'4px', borderColor:"black", background: '#FCE1E4', color: '#000' } }, // blush pink
  },
  {
    id: 35,
    group: 15,
    title: 'Nicolas Yamato',
    start_time: moment('2025-07-05'),
    end_time: moment('2025-07-07'),
    itemProps: { style: { borderRadius:'4px', borderColor:"black", background: '#D3F8E2', color: '#000' } }, // soft mint
  }
];
